import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import CRMModules from './CRMModules';

const enhance = compose(
  withTranslation(['common']),
);
export default enhance(CRMModules);
